<div class="widgets-group" [style]="containerStyles()" [class]="styleClass()">
  <ng-content></ng-content>
</div>
